import { Record } from 'immutable'

export interface IPrivateNote {
  readonly subjectId: string
  readonly note: string
}

const PrivateNoteRecord = Record({
  note: '',
  subjectId: '',
})

export class PrivateNote extends PrivateNoteRecord implements IPrivateNote {
  public static fromJS(initialState?: Partial<IPrivateNote>) {
    return new PrivateNote(initialState)
  }

  public readonly subjectId: string
  public readonly note: string

  constructor(initialState?: Partial<PrivateNote>) {
    initialState ? super(initialState) : super()
  }
}
